var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeepLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 34.9995 0 34.9995 35.0002778 0 35.0002778"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "My-Schedule",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "My-Schedule-(-Coach-)-new",
    transform: "translate(-1701.000000, -525.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(1701.000000, 525.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6423888,10.4165294 C23.3112867,9.74763152 24.386579,9.73790916 25.0574214,10.4087515 C25.7204859,11.0718161 25.7321527,12.1393305 25.0476991,12.8218397 L20.1359661,17.7355171 C19.4670682,18.4024705 18.3917759,18.4121929 17.722878,17.743295 C17.057869,17.078286 17.0462022,16.0107716 17.7306559,15.3282624 L22.6423888,10.4165294 Z M27.4238422,17.6655161 L25.018532,15.2582614 L31.1144476,9.16234584 C31.6725107,8.60428276 31.3575064,6.93787139 29.9419318,5.52229673 C28.5360795,4.1183889 26.8560568,3.79560677 26.3096605,4.34200303 L20.2059671,10.447641 L17.8006568,8.04038626 L23.9024058,1.9366928 C26.0568793,-0.215836245 29.8097078,0.499728965 32.3880759,3.07809709 C34.9761664,5.66813203 35.6820092,9.40734915 33.5217023,11.5676561 L27.4238422,17.6655161 Z M22.5684989,17.7082945 L24.9738092,20.1155492 L18.8778936,26.2134092 C16.7175867,28.3737162 12.9764251,27.6678733 10.3883346,25.0778384 C7.80996649,22.4994702 7.0924568,18.7485863 9.24693032,16.5941128 L15.3506238,10.4904193 L17.755934,12.8957295 L11.6522405,18.999423 C11.1058443,19.5458193 11.4266819,21.2277864 12.8325343,22.6316942 C14.2481089,24.0472689 15.9145203,24.3622731 16.4725834,23.8042101 L22.5684989,17.7082945 Z M17.6956554,3.87921901 L17.6956554,3.88894136 L7.76135472,3.88894136 C5.63604827,3.88894136 3.88796912,5.63313156 3.88796912,7.76816037 L3.88796912,27.2323119 C3.88796912,29.3712296 5.62827038,31.1115309 7.76718813,31.1115309 L27.2313396,31.1115309 C29.3702574,31.1115309 31.1105586,29.3692851 31.1105586,27.2225895 L31.1105586,19.399984 C31.1358368,18.3480253 31.9972373,17.5002361 33.0550293,17.5002361 C34.1147658,17.5002361 34.9761664,18.3480253 34.9995,19.399984 L34.9995,27.2225895 C34.9995,31.5179252 31.5150085,35.0004722 27.2313396,35.0004722 L7.76718813,35.0004722 C3.47768581,35.0004722 -0.00097223534,31.5159808 -0.00097223534,27.2323119 L-0.00097223534,7.76816037 C-0.00097223534,3.47865805 3.49518605,0 7.76135472,0 L17.6956554,0 L17.6956554,0.0097223534 C18.6776131,0.106945887 19.4437346,0.937234868 19.4437346,1.94447068 C19.4437346,2.95365096 18.6776131,3.78199547 17.6956554,3.87921901 L17.6956554,3.87921901 Z",
    id: "Fill-1",
    fill: "#F22B5D",
    mask: "url(#mask-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeepLink);
export default __webpack_public_path__ + "static/media/deepLink.3ae535cf3c85a6c289068b74d42396ab.svg";
export { ForwardRef as ReactComponent };